var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"pointer",attrs:{"src":"/assets/img/edit.png","alt":"update tax","width":"25px"},on:{"click":_vm.openEditSubPlan}}),_c('EditSubscriptionPlanModal',{attrs:{"id":_vm.sub.id,"closeModal":_vm.closeModal,"sub":_vm.sub,"refetch":_vm.refetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }